import MathRenderer from "../components/taskUser copy 3.js"
import React, { Component } from 'react';
// import Markdownkatexnew from "./Markdown.js";
// import WindowFocusHandler from "./isvisible.js";
// import Blog from "../components/taskUser copy 2.js";
import Navigation from '../screens/Navigation.jsx';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify'
// import { Link } from 'react-router-dom';
import axios from 'axios'
import Select, { components } from 'react-select';
import { CKEditor } from '@ckeditor/ckeditor5-react';
// import Socket from "../screens/Chat.jsx";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import { ClassicEditor, Essentials, Paragraph, Bold, Italic, Toolbar } from 'ckeditor5';
// import Math from 'ckeditor5-math/src/math';
// import TimeAgo from 'timeago-react';
// import Timer from './timer.js';
import * as timeago from 'timeago.js';
import es from 'timeago.js/lib/lang/es';
import 'katex/dist/katex.min.css'; // Don't forget the KaTeX stylesheet
import { registerLocale } from "react-datepicker";
import { parseISO } from "date-fns";
import wes from 'date-fns/locale/es';
// import { isAuth } from "../helpers/auth.js";
registerLocale('es', wes);
timeago.register('es', es);

export default class Tests extends Component {

  constructor(props) {
    super(props);
    this.state = {
      solution: "",
      task: "",
      items: [],
      itemsnew: [],
      itemsnewnew: [],
      theme: "",
      dateb: new Date(),
      datee: "",
      note: "",
      setLoading: false,
      noww: "",
    }
  };

  getNotes = async () => {
    await axios.get(
      `${process.env.REACT_APP_API_URL}/tasks/${this.props.match.params.idtest}`
    ).then(res => {
      console.log(res.data, "www");
      if (res.data && res.data.length != 0) {
        this.setState({
          dateb: parseISO(res.data.dateb),
          datee: parseISO(res.data.datee),
          theme: res.data,
          idcurse: res.curse,
          items: res.data.items,
          itemsnew: JSON.stringify(res.data.items),
          solution: res.data.solution,
          task: res.data.task,
        });
        localStorage.setItem("test", JSON.stringify(res.data.items));
        this.CargarStorage()
      } else {
        // history.push("/categorias");
      }
    });
  }

  getNotesNotes = async () => {
    await axios.get(
      `${process.env.REACT_APP_API_URL}/tasks/${this.props.match.params.idtest}`
    ).then(res => {
      this.setState({
        theme: res.data[0],
      });
      console.log(res.data[0]);
      console.log(this.state.theme.task, this.state.theme.note);
    });
  }

  submitTest = async (items) => {
    const Data = {
      task: this.state.task,
      solution: this.state.solution,
      items: items,
      // note: note
    };
    await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${this.props.match.params.idtest}`, Data).then(res => {
      toast.dark(res.data)
      // this.getNotes()
    });
  };

  CargarStorage = async () => {
    // console.log(isValidJSON(localStorage.getItem("test")))
    this.setState({
      itemsnewnew: JSON.parse(localStorage.getItem("test")),
    })
  };

  async componentDidMount() {
    await this.getNotes()
  }

  onChange = (text) => (e) => {
    var www = this.state.items
    www[text].std = e.label[0]
    this.setState({
      items: www
    })
  }

  onChangeText = (text, i, obsstd) => {
    function getLevenshteinSimilarity(str1, str2) {
      const track = Array(str2.length + 1).fill(null).map(() =>
        Array(str1.length + 1).fill(null)
      );
      for (let i = 0; i <= str1.length; i += 1) track[0][i] = i;
      for (let j = 0; j <= str2.length; j += 1) track[j][0] = j;
      for (let j = 1; j <= str2.length; j += 1) {
        for (let i = 1; i <= str1.length; i += 1) {
          const indicator = str1[i - 1] === str2[j - 1] ? 0 : 1;
          track[j][i] = Math.min(
            track[j - 1][i] + 1, // deletion
            track[j][i - 1] + 1, // insertion
            track[j - 1][i - 1] + indicator // substitution
          );
        }
      }
      const distance = track[str2.length][str1.length];
      const maxLength = Math.max(str1.length, str2.length);
      if (maxLength === 0) return 100;
      return ((maxLength - distance) / maxLength) * 100;
    }

    var newww = this.state.itemsnewnew
    console.log(text, i, obsstd)
    ///////////////////////////////////////////////////////////////////
    for (var j = 0; j < newww.length; j++) {
      if (newww[j].alt) {
      } else {
        var rrr = newww[j].std.replace(/&nbsp;/g, '').replace(/<\/?[^>]+(>|$)/g, "").replace(/\s+/g, '')
        var rrrobs = newww[j].obs.replace(/&nbsp;/g, '').replace(/<\/?[^>]+(>|$)/g, "").replace(/\s+/g, '')
        newww[j].pctgsimilar = getLevenshteinSimilarity(rrr, rrrobs)
      }
    }
    ///////////////////////////////////////////////////////////////////
    if (obsstd === 'std') {
      newww[i].std = text
    } else {
      newww[i].obs = text
    }
    if (newww != null) { this.submitTest(newww) }
  }

  MarkdownOption = (props) => {
    return (
      <components.Option {...props}>
        <MathRenderer>{props.data.label[0]}</MathRenderer>
      </components.Option>
    );
  };

  MarkdownSingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <MathRenderer>{props.data.label[0]}</MathRenderer>
      </components.SingleValue>
    );
  };


  render() {
    return (
      <div className=''>
        <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />
        <Navigation />

        {/* <Timer endDate={this.state.datee} onFinish={this.handleFromChild} /> */}

        <div className='container'>
          {/* <WindowFocusHandler onDataReceived={this.handleDataFromChild} /> */}
          {/* <Blog /> */}

          <div>
            <div className='row justify-content-center align-items-center border d-flex' style={{ margin: '.5em' }}>
              {this.state.itemsnewnew ?
                this.state.itemsnewnew.map((number, i) =>
                  <div key={i + 1} className={`${number.alt ? 'col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1' : 'col-sm-12 col-md-12 col-lg-12'}`}>
                    <div className="">
                      [{i + 1}]
                      <MathRenderer>
                        {number.prg}
                      </MathRenderer>
                      <div className="p-1 bg-warning">
                        {number.alt ?
                          <div className='marginbottomp'>
                            <Select onChange={this.onChange(i)} options={
                              number.alt.map((guest, index) => {
                                return {
                                  label: guest,
                                  value: guest,
                                  key: index
                                }
                              })
                            } components={{ Option: this.MarkdownOption, SingleValue: this.MarkdownSingleValue }} />
                          </div>
                          :
                          <div>
                            <CKEditor editor={ClassicEditor} config={{
                              language: 'es', placeholder: "Descripción",
                              toolbar: ["undo", "redo", "|", "math", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "insertTable", "mediaEmbed", "heading"],
                              math: {
                                engine: 'katex',
                                outputType: 'span',
                                forceOutputType: false,
                                enablePreview: true
                              }
                            }} data={number.obs.includes("math-tex") ? number.obs : number.obs.replace(/\\\]/g, '\\]<\/span>').replace(/\\\[/g, '<span class="math-tex">\\[').replace(/\\\)/g, '\\)<\/span>').replace(/\\\(/g, '<span class="math-tex">\\(')}
                              onBlur={(event, editor) => {
                                this.onChangeText(editor.getData(), i, 'obs')
                              }}
                            />
                            <CKEditor editor={ClassicEditor} config={{
                              language: 'es', placeholder: "Descripción",
                              toolbar: ["undo", "redo", "|", "math", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "insertTable", "mediaEmbed", "heading"],
                              math: {
                                engine: 'katex',
                                outputType: 'span',
                                forceOutputType: false,
                                enablePreview: true
                              }
                            }} data={number.std.includes("math-tex") ? number.std : number.std.replace(/\\\]/g, '\\]<\/span>').replace(/\\\[/g, '<span class="math-tex">\\[').replace(/\\\)/g, '\\)<\/span>').replace(/\\\(/g, '<span class="math-tex">\\(')}
                              onBlur={(event, editor) => {
                                this.onChangeText(editor.getData(), i, 'std')
                              }}
                            />
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                ) : ''
              }
            </div>
          </div>


          {/* <div>
            <div className='row justify-content-center align-items-center' style={{ margin: '.5em' }}>
              {this.state.items ? this.state.items.map((number, i) =>
                <div key={i + 1} className={`${number.alt ? 'col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1' : 'col-sm-12 col-md-12 col-lg-12'}`}>
                  <div className="p-1 bg-light rounded">
                    [{i + 1}]
                    <MathRenderer>
                      {number.prg}
                    </MathRenderer>
                    {number.alt ?
                      <div className='marginbottomp'>
                        <Select onChange={this.onChange(i)} options={
                          number.alt.map((guest, index) => {
                            return {
                              label: guest,
                              value: guest,
                              key: index
                            }
                          })
                        } components={{ Option: this.MarkdownOption, SingleValue: this.MarkdownSingleValue }} />
                      </div>
                      :
                      <div>
                        <CKEditor editor={ClassicEditor} config={{
                          language: 'es', placeholder: "Descripción",
                          toolbar: ["undo", "redo", "|", "math", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "insertTable", "mediaEmbed", "heading"],
                          math: {
                            engine: 'katex',
                            outputType: 'span',
                            forceOutputType: false,
                            enablePreview: true
                          }
                        }} data={number.obs.includes("math-tex") ? number.obs : number.std.replace(/\\\]/g, '\\]<\/span>').replace(/\\\[/g, '<span class="math-tex">\\[').replace(/\\\)/g, '\\)<\/span>').replace(/\\\(/g, '<span class="math-tex">\\(')}
                          onBlur={(event, editor) => {
                            this.onChangeText(editor.getData(), i, 'obs')
                          }} onReady={editor => {
                          }}
                        />
                        <CKEditor editor={ClassicEditor} config={{
                          language: 'es', placeholder: "Descripción",
                          toolbar: ["undo", "redo", "|", "math", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "insertTable", "mediaEmbed", "heading"],
                          math: {
                            engine: 'katex',
                            outputType: 'span',
                            forceOutputType: false,
                            enablePreview: true
                          }
                        }} data={number.std.includes("math-tex") ? number.std : number.std.replace(/\\\]/g, '\\]<\/span>').replace(/\\\[/g, '<span class="math-tex">\\[').replace(/\\\)/g, '\\)<\/span>').replace(/\\\(/g, '<span class="math-tex">\\(')}
                          onChange={(event, editor) => {
                            this.onChangeText(editor.getData(), i, 'std')
                          }}
                        />
                      </div>

                    }
                  </div>
                </div>
              ) : ''}
            </div>
            </div> */}
          <textarea className="form-control" defaultValue={this.state.itemsnew} rows={8} onChange={(event) => {
            localStorage.setItem("test", event.target.value);
            console.log(JSON.parse(localStorage.getItem("test")) ? JSON.parse(localStorage.getItem("test")) : 'none')
          }}
            required="required">
          </textarea>

          <>
            {/* <button className="btn btn-info w-100" onClick={() => { this.submitTest(this.state.items, this.state.note) }} disabled={this.state.setLoading}>
              Guardar
            </button> */}
            <button className="btn btn-warning w-100 my-1" onClick={() => { this.CargarStorage() }} disabled={this.state.setLoading}>
              Cargar Storage
            </button>
          </>
        </div>
        {/* <Socket /> */}
      </div >
    );
  }
}
